import { use } from 'react';
import type { ApplicationListItem } from '@like-aiop/backend/src/api/applications/types';
import { createApplicationsPromise } from '../api/applicationsPromise';
import { guardedClient } from '../../auth/api/clients';
import type { Honbu } from '../types';

/**
 * 指定した本部の架電履歴一覧を返す。
 * 取得完了まで suspend するため Suspense 境界内で呼ぶこと。取得失敗は ErrorBoundary に伝播する。
 */
export const useApplications = (honbu: Honbu): ApplicationListItem[] => {
  const promise = createApplicationsPromise(guardedClient, honbu);
  return use(promise);
};
